import { Link } from 'found'
import React, { Component } from 'react'
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro' 

import { msToReadingTime } from '../../utils'

import timeIcon from '../../images/time.svg'

function FeaturedSection({ routeResolver, articles }) {

    const first = articles[0]
    const firstRow = articles.slice(1, 3)
    const secondRow = articles.slice(3, 6)
    
    return (
        <div className="recent-articles">
            <div className="berlin-row">
                <div className="row-11 w-row">
                    {first &&
                        <div className="column-32 w-col w-col-6 w-col-stack">
                            <Link
                                to={routeResolver.article.get((first.city || first.category).slug, first.slug)}
                                className="link-block-9 w-inline-block"
                            />
                            <img alt="" src={first.picture} className="image-headline" />
                            <div
                                style={{ background: (first.city || first.category).color }}
                                className="berlin-featured-story"
                            >
                                <h3 className="heading-7 berlin-box">
                                    <span style={{ textTransform: 'uppercase' }} className="span berlin">
                                        {(first.city || first.category).name}
                                    </span>
                                    &nbsp;{first.title}<br />‍
                                </h3>
                                <div className="div-block-15">
                                    <div className="text-block-13">
                                        {first.author.firstname} {first.author.lastname}
                                    </div>
                                    <img alt="" src={timeIcon} width={13} height={13} className="image-24" />
                                    <div className="text-block-13">{msToReadingTime(first.readingTime)}</div>
                                </div>
                            </div>
                        </div>
                    }
                    {firstRow.map((a, i) =>
                        <div key={i} className="w-col w-col-3 w-col-stack" style={{ background: (a.city || a.category).color }}>
                            <Link
                                to={routeResolver.article.get((a.city || a.category).slug, a.slug)}
                                className="link-block-9 w-inline-block"
                            />
                            <img alt="" src={a.picture} className="image-headline primary" />
                            <div
                                style={{ background: (a.city || a.category).color }}
                                className="featured"
                            >
                                <h3 className="heading-featured business-box-copy">
                                    <span style={{ textTransform: 'uppercase' }} className="span business">
                                        {(a.city || a.category).name}
                                    </span>
                                    &nbsp;{a.title}
                                </h3>
                                <div className="text-block-13">
                                    {a.author.firstname} {a.author.lastname}
                                </div>
                                <img alt="" src={timeIcon} width={13} height={13} className="image-24" />
                                <div className="text-block-13">{msToReadingTime(a.readingTime)}</div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="row-12 w-row">
                    {/* <div className="column-58 w-col w-col-3 w-col-stack" /> */}
                    {secondRow.map((a, i) =>
                        <div key={i} className="w-col w-col-3 w-col-stack" style={{ background: (a.city || a.category).color }}>
                            <Link
                                to={routeResolver.article.get((a.city || a.category).slug, a.slug)}
                                className="link-block-9 w-inline-block"
                            />
                            <img alt="" src={a.picture} className="image-headline primary" />
                            <div
                                style={{ background: (a.city || a.category).color }}
                                className="featured-i-nnovation"
                            >
                                <h3 className="heading-8 berlin-box">
                                    <span style={{ textTransform: 'uppercase' }} className="span business">
                                        {(a.city || a.category).name}
                                    </span>
                                   {' '}{a.title}<br />‍
                                </h3>
                                <div className="text-block-13">{a.author.firstname} {a.author.lastname}</div><img alt="" src={timeIcon} width={13} height={13} className="image-24" />
                                <div className="text-block-13">{msToReadingTime(a.readingTime)}</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}


const connectRelay = FeaturedSection => class extends Component {
    setFeaturedBlockSize(){
        var elems1 = document.querySelector('.row-11').querySelectorAll('.w-col-3');
        var elems2 = document.querySelector('.row-12').querySelectorAll('.w-col-3');
        var elems = [...elems1, ...elems2];
        
        for (let i = 0 ; i < elems.length; i++) {
            elems[i].style.height = '';
        }
        if(window.innerWidth < 992) return;
        var maxHeightElem = Math.max.apply(Math, [...elems].map(a => { return a.clientHeight }))
        for (let i = 0 ; i < elems.length; i++) {
            elems[i].style.height = ''+maxHeightElem+'px';
        }
    }

    componentDidMount() {
        window.addEventListener('resize', this.setFeaturedBlockSize);
        setTimeout ( () => {
            this.setFeaturedBlockSize();
        }, 1000);
    }

    render() {
        return <FeaturedSection
            routeResolver={this.props.context.routeResolver}
            articles={this.props.home.featuredContent}
        />
    }
}

export default createFragmentContainer(
    connectRelay(FeaturedSection),
    graphql`
        fragment featuredSection_home on Home {
            featuredContent {
                slug
                title
                caption
                readingTime
                picture
                author {
                    firstname
                    lastname
                }
                city {
                    slug
                    name
                    color
                }
                category {
                    slug
                    name
                    color
                }
            }
        }
    `
)
